exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._label[data-v-88d6930e]{position:relative;display:inline-block}._label .tooltiptext[data-v-88d6930e]{visibility:hidden;width:140px;background-color:#555;color:#fff;text-align:center;border-radius:6px;padding:5px;position:absolute;z-index:1;bottom:150%;left:50%;margin-left:-75px;opacity:0;-webkit-transition:opacity .3s;transition:opacity .3s}._label .tooltiptext[data-v-88d6930e]:after{content:\"\";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:#555 transparent transparent}._label:hover .tooltiptext[data-v-88d6930e]{visibility:visible;cursor:pointer;opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-88d6930e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Copy/CopyToClipBoard.vue
// module id = rKJp
// module chunks = 0 1 3 4 5 6 7 8 9